
































































































































import { Vue, Component, Ref } from "vue-property-decorator";
import { Scope as IScope } from "@/api/models/scope";
import CustomInput from "@/components/form/CustomInput.vue";
import { ApplicationCreate as IApplicationCreate } from "@/api/models/application-create";
import { Application as IApplication } from "@/api/models/application";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { Tree as TreeSort } from "@/plugins/tree";
import { Check, Tree } from "he-tree-vue";
import "he-tree-vue/dist/he-tree-vue.css"; // base style for draggable plugin
import api from "@/getinfo-api";

@Component({ components: { CustomInput, Tree: Tree.mixPlugins([Check]) } })
export default class ApiKeysGeneratingForm extends Vue {
  @Ref("customInputIp") customInputIp: any;
  @Ref("customInputHost") customInputHost: any;
  @Ref("treeRef") _tree!: any;
  title!: string;
  description!: string;
  scopes: Array<string> = [];
  allowedIps: Array<string> = [];
  allowedHosts: Array<string> = [];
  allowedScopes!: Array<IScope>;
  ip!: string;
  host!: string;
  allScopedActive: boolean = false;
  app!: IApplication;
  sortedArray: Array<any> = [];
  isSpinner: boolean = false;

  data() {
    return {
      title: undefined,
      description: undefined,
      allowedScopes: undefined,
      ip: undefined,
      host: undefined,
      app: undefined
    };
  }

  copyToken() {
    if (this.app.token) {
      try {
        navigator.clipboard.writeText(this.app.token.toString());
      } catch (e) {
        throw e;
      }
      this.$bvToast.toast(`${this.$tc(this.$translate.Successful)}`, {
        variant: "success",
        title: `${this.$tc(this.$translate.Success)}`
      });
    }
  }

  changeCheckBoxes(node: any, path: any) {
    this._tree.toggleCheck(node, path);
    let a: any = [];

    let funcGetChild = (item: any) => {
      if (item.children.length) {
        item.children.forEach((el: any) => funcGetChild(el));
        a.push(item);
      } else {
        a.push(item);
      }
    };

    this.sortedArray.forEach(el => {
      funcGetChild(el);
    });

    this.scopes = a
      .filter((el: any) => el.hasOwnProperty("$checked") && el.$checked)
      .map((el: any) => el.node.id);
  }

  sortedScope() {
    const options = this.allowedScopes.map(el => {
      return {
        id: el.id,
        parentId: el.parentId || null,
        entity: el
      };
    });
    const tree = new TreeSort(options);
    this.sortedArray = tree.getTreeItems();
  }

  generateKey() {
    this.isSpinner = true;
    let params: IApplicationCreate = {
      title: this.title,
      description: this.description,
      scopes: this.scopes,
      allowedIps: this.allowedIps,
      allowedHosts: this.allowedHosts
    };
    api.ApplicationApi.create(params)
      .then((res: { data: IApplication }) => {
        this.app = res.data;
        this.isSpinner = false;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.isSpinner = false;
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
  getScopesList() {
    api.ApplicationApi.scopesList()
      .then((res: { data: Array<IScope> }) => {
        this.allowedScopes = res.data;
        this.sortedScope();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  clearArray(str: string) {
    let arr: Array<string>;
    arr = str.split(",");
    arr = arr.map(el => {
      return el.trim();
    });
    arr = arr.filter(el => {
      if (el !== "") return el;
    });
    return arr;
  }

  addIp() {
    if (this.ip.indexOf(",")) {
      this.allowedIps = this.allowedIps.concat(this.clearArray(this.ip));
      this.ip = "";
      this.customInputIp.body = undefined;
      this.customInputIp.formattedBody = undefined;
      this.customInputIp.state = null;
    } else {
      this.allowedIps.push(this.ip);
      this.ip = "";
      this.customInputIp.body = undefined;
      this.customInputIp.formattedBody = undefined;
      this.customInputIp.state = null;
    }
  }

  addHost() {
    if (this.host.indexOf(",")) {
      this.allowedHosts = this.allowedHosts.concat(this.clearArray(this.host));
      this.host = "";
      this.customInputHost.body = undefined;
      this.customInputHost.formattedBody = undefined;
      this.customInputHost.state = null;
    } else {
      this.allowedHosts.push(this.host);
      this.host = "";
      this.customInputHost.body = undefined;
      this.customInputHost.formattedBody = undefined;
      this.customInputHost.state = null;
    }
  }

  setIp(item: string) {
    this.ip = item;
  }

  setHost(item: string) {
    this.host = item;
  }

  deleteItem(item: any, index: number) {
    if (item === "host") {
      this.allowedHosts.splice(index, 1);
    } else if (item === "ip") {
      this.allowedIps.splice(index, 1);
    }
  }

  created() {
    this.getScopesList();
  }
}
